import {AppDispatch} from '../store';
import {Data} from '../types/FilterDefaultType';
import {getJsonData} from './requests';

export const getAllFilterDefaults = (dispatch: AppDispatch): Promise<Data> => {
    const url = `api/1.0/filterDefaults`;
    return getJsonData(url, dispatch);
};